import React from 'react';

export default () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><defs><clipPath id="b"><rect width="30" height="30"/></clipPath></defs><g id="a" clipPath="url(#b)"><path d="M-11.282-25.764-12.7-34.888l-7.192-5.8L5.475-45.39Zm-6.293-14.328,5.394,4.323L1.439-43.63Zm5.892,5.184,1.052,6.848L1.936-42.769Z" transform="translate(21.89 51.391)" fill="#fff"/></g></svg>
);
}